import { Box, Typography } from "@mui/material"
import { normalizeActions } from "library/normalizeActions.mjs"
import { Comparison } from "routes/schedule/compare/lib/diff3"

export function AuthoringReviewIntroValue({ label, value, comparisonValue, showRemoved, dataCy }) {
    const displayValue = normalizeActions(value || "")
    const displayComparison = comparisonValue != null ? normalizeActions(comparisonValue || "") : displayValue

    return (
        <Box py={1.5} data-cy={dataCy}>
            <Typography variant="overline">{label}</Typography>
            <Comparison
                text={displayValue}
                original={displayComparison}
                other={displayComparison}
                showRemoved={showRemoved}
            />
        </Box>
    )
}
